"use strict";
/*
 * Created on 03.05.2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowItemHistoryTable_1 = require("../model/WindowItemHistoryTable");

var WindowItemHistoryTableConverter_1 = require("./WindowItemHistoryTableConverter");
/**
 * @author Tomas Leity
 */


var WindowItemHistoryTableConverterImpl =
/*#__PURE__*/
function (_WindowItemHistoryTab) {
  _inherits(WindowItemHistoryTableConverterImpl, _WindowItemHistoryTab);

  function WindowItemHistoryTableConverterImpl() {
    _classCallCheck(this, WindowItemHistoryTableConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemHistoryTableConverterImpl).apply(this, arguments));
  }

  _createClass(WindowItemHistoryTableConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WindowItemHistoryTable_1.WindowItemHistoryTable(WindowItemHistoryTable_1.WindowItemHistoryTable.schema.promotionCode.valueOfField(source), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.promotionType.valueOfField(source), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.promotionName.valueOfField(source), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.windowType.valueOfField(source), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.promoPrice.valueOf(conversions.toBigNumber(source.promoPrice)), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.promoVolume.valueOf(conversions.toBigNumber(source.promoVolume)), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.realVolume.valueOf(conversions.toBigNumber(source.realVolume)), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.windowDateFrom.valueOfField(source), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.windowDateTo.valueOfField(source), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.daysValid.valueOfField(source), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.numberOfStores.valueOfField(source), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.secondaryPlacement.valueOfField(source), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.osa.valueOf(conversions.toBigNumber(source.osa)), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.regularPrice.valueOf(conversions.toBigNumber(source.regularPrice)), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.onPicture.valueOfField(source), WindowItemHistoryTable_1.WindowItemHistoryTable.schema.tvCommercial.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        promotionCode: source.promotionCode,
        promotionType: source.promotionType,
        promotionName: source.promotionName,
        windowType: source.windowType,
        promoPrice: conversions.fromBigNumber(source.promoPrice),
        promoVolume: conversions.fromBigNumber(source.promoVolume),
        realVolume: conversions.fromBigNumber(source.realVolume),
        windowDateFrom: conversions.fromDate(source.windowDateFrom),
        windowDateTo: conversions.fromDate(source.windowDateTo),
        daysValid: source.daysValid,
        numberOfStores: source.numberOfStores,
        secondaryPlacement: source.secondaryPlacement,
        osa: conversions.fromBigNumber(source.osa),
        regularPrice: conversions.fromBigNumber(source.regularPrice),
        onPicture: source.onPicture,
        tvCommercial: source.tvCommercial
      });
      return result;
    }
  }]);

  return WindowItemHistoryTableConverterImpl;
}(WindowItemHistoryTableConverter_1.WindowItemHistoryTableConverter);

exports.WindowItemHistoryTableConverterImpl = WindowItemHistoryTableConverterImpl;